import React from 'react'
import { RequestError } from 'src/common-services'
import { InsightCard } from 'src/components/insights/common/cards'
import { Typography } from '@mui/material'

type NotFoundProps = {
  title: string
  message: string
  children: React.ReactNode
}

export class NotFoundErrorBoundary extends React.Component<NotFoundProps, any> {
  state = { notFound: false }
  componentDidCatch(error: Error) {
    if (error instanceof RequestError) {
      if (error.status === 404) {
        this.setState({ notFound: true })
        return
      }
    }
    throw error
  }

  render() {
    if (this.state.notFound) {
      const { title, message } = this.props
      return (
        <InsightCard title={title}>
          <Typography variant="text1">{message}</Typography>
        </InsightCard>
      )
    }
    return this.props.children
  }
}
